import { render, staticRenderFns } from "./BookingCheckoutComponent.vue?vue&type=template&id=6c8b003c&scoped=true"
import script from "./BookingCheckoutComponent.vue?vue&type=script&lang=js"
export * from "./BookingCheckoutComponent.vue?vue&type=script&lang=js"
import style0 from "./BookingCheckoutComponent.vue?vue&type=style&index=0&id=6c8b003c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8b003c",
  null
  
)

export default component.exports